module.exports = __webpack_public_path__ + "static/media/active-bond.cf5a7c85.svg";